import { db } from "firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { CouponType, couponConverter } from "types/firestoreTypes";
import DefaultTemplate from "components/templates/DefaultTemplate";

const Coupon = () => {
    const [coupon, setCoupon] = useState<CouponType | null>(null);
    useEffect(() => {
        (async () => {
            const res = (
                await getDoc(
                    doc(db, "coupon/coupon").withConverter(couponConverter)
                )
            ).data();
            if (!res) throw new Error("coupon document is not found");
            setCoupon(res);
        })();
    }, []);

    return (
        <DefaultTemplate style={{ textAlign: "center" }}>
            <h2>ログイン特典!</h2>
            {coupon && (
                <div style={{ width: "80%", margin: "0 auto" }}>
                    <div>
                        <img
                            src={coupon.image}
                            alt="logo"
                            style={{ width: "100%" }}
                        />
                    </div>
                    <span>{coupon.text}</span>
                </div>
            )}
            {!coupon && <h2>Now Loading...</h2>}
        </DefaultTemplate>
    );
};

export default Coupon;
